import { render, staticRenderFns } from "./enrollmentManagementList.vue?vue&type=template&id=f77145d4&scoped=true"
import script from "./enrollmentManagementList.vue?vue&type=script&lang=js"
export * from "./enrollmentManagementList.vue?vue&type=script&lang=js"
import style0 from "./enrollmentManagementList.vue?vue&type=style&index=0&id=f77145d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77145d4",
  null
  
)

export default component.exports